import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, IconButton, Typography, Button, Drawer, List, ListItem, ListItemText, useTheme, useMediaQuery, Box, ListItemButton, CssBaseline } from '@mui/material';
import { Link, To, useNavigate } from "react-router-dom";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PhoneIcon from '@mui/icons-material/Phone';
import MailIcon from '@mui/icons-material/Mail';
import MenuIcon from '@mui/icons-material/Menu';
import './Header.css';


interface HeaderProps {
    variant:
    1 | 2;
}

const drawerWidth = 240;
const navItems = ['Inicio', 'Nosotros', 'Portafolio', 'Sedes', 'Contacto'];

const Header: React.FC<HeaderProps> = ({ variant }) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));

    const navigate = useNavigate();
    const handleNavigation = (path: To) => {
        navigate(path);
        window.scrollTo(0, 0);
    };

    const [isScrolled, setIsScrolled] = useState(false);

    const [mobileOpen, setMobileOpen] = React.useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center', paddingTop: '20px' }}>
            <img src='/Assets/logo1-nobg.png' alt='grupo' style={{ height: '65px' }} />
            <List>
                {navItems.map((item) => (
                    <ListItem key={item} disablePadding>
                        <ListItemButton
                            sx={{
                                textAlign: 'center',
                                padding: '15px',
                                '&:hover': {
                                    backgroundColor: 'transparent',
                                    '& .MuiListItemText-primary': {
                                        color: '#ff6c00',
                                    }
                                }
                            }}
                            disableRipple
                            onClick={() => handleNavigation(item === 'Inicio' ? '/' : `/${item}`)}
                        >
                            <ListItemText primary={item} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Box>
    );

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        const threshold = 50;

        setIsScrolled(scrollTop > threshold);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const whatsappNumber = '3108142180';
    const whatsappLink = `https://wa.me/${whatsappNumber}`;

    if (variant === 1 && !isSmallScreen) {
        return (
            <>
                <div
                    className={`top-bar ${isScrolled ? 'scrolled' : ''}`}
                >
                    <div className='top-bar-info'>
                        <Typography
                            variant="body1"
                            style={{ marginRight: '5px', fontFamily: 'Inter, sans-serif', fontSize: '1.0625em' }}
                        >
                            ¿Necesitas ayuda?
                        </Typography>
                        <Link
                            to={whatsappLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                color: isScrolled ? 'White' : 'transparent',
                                display: 'flex',
                                alignItems: 'center',
                                textDecoration: 'none',
                                fontFamily: 'Inter, sans-serif',
                                fontSize: '1.0625em',
                            }}
                        >
                            Contáctanos
                            <WhatsAppIcon style={{ marginBottom: '3px', marginLeft: '5px' }} />
                        </Link>
                    </div>

                    <div className='top-bar-info'>
                        <div className="phone-info" style={{ color: isScrolled ? 'White' : 'transparent' }}>
                            <MailIcon />
                            <Typography
                                variant="body1"
                                style={{ marginLeft: '5px', fontFamily: 'Inter, sans-serif', fontSize: '1.0625em' }}
                            >
                                gerencia@rocaseguros.com
                            </Typography>
                        </div>
                        <div className="sep" style={{ backgroundColor: isScrolled ? 'White' : 'transparent' }} />
                        <div className="phone-info">
                            <PhoneIcon />
                            <Typography
                                variant="body1"
                                style={{ marginLeft: '5px', fontFamily: 'Inter, sans-serif', fontSize: '1.0625em' }}
                            >
                                (608) 761 9551
                            </Typography>
                        </div>
                    </div>

                </div>
                <AppBar
                    position="fixed"
                    sx={{
                        backgroundColor: isScrolled ? 'White' : 'transparent',
                        alignItems: isScrolled ? '' : 'center',
                        paddingLeft: isScrolled ? '10%' : '',
                        paddingRight: isScrolled ? '9.5%' : '',
                        justifyContent: 'center',
                        marginTop: '2.375em',
                        boxShadow: isScrolled ? '' : 'none',
                        top: 0,
                        zIndex: 1000,
                        transition: 'background-color 0.4s ease-in-out',
                    }}
                >
                    <Toolbar sx={{ fontWeight: 'bold', color: isScrolled ? 'black' : 'white', gap: '20px' }}>
                        <div style={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                            <Link to="/">
                                <img
                                    src="/Assets/logo-nobg.png"
                                    style={{ height: isScrolled ? '65px' : '100px', marginTop: '10px' }}
                                    alt="logo"
                                />
                            </Link>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', color: isScrolled ? '#3b3b3b' : 'white', gap: '30px' }}>
                            <>
                                <Button
                                    color="inherit"
                                    disableRipple
                                    sx={{
                                        textTransform: "none",
                                        fontSize: isScrolled ? '1.1250em' : '1.3750em',
                                        padding: '12px',
                                        fontFamily: "Inter, sans-serif",
                                        '&:hover': {
                                            color: '#ff6c00',
                                            backgroundColor: 'transparent',
                                        },
                                    }}
                                    onClick={() => handleNavigation('/')}
                                >
                                    Inicio
                                </Button>
                                <Button
                                    color="inherit"
                                    disableRipple
                                    sx={{
                                        fontSize: isScrolled ? '1.1250em' : '1.3750em',
                                        padding: '12px',
                                        textTransform: "none",
                                        fontFamily: "Inter, sans-serif",
                                        '&:hover': {
                                            color: '#ff6c00',
                                            backgroundColor: 'transparent',
                                        },
                                    }}
                                    onClick={() => handleNavigation('/Nosotros')}
                                >
                                    Nosotros
                                </Button>
                                <Button
                                    color="inherit"
                                    disableRipple
                                    sx={{
                                        fontSize: isScrolled ? '1.1250em' : '1.3750em',
                                        padding: '12px',
                                        textTransform: "none",
                                        fontFamily: "Inter, sans-serif",
                                        '&:hover': {
                                            color: '#ff6c00',
                                            backgroundColor: 'transparent',
                                        },
                                    }}
                                    onClick={() => handleNavigation('/Portafolio')}
                                >
                                    Portafolio
                                </Button>
                                <Button
                                    color="inherit"
                                    disableRipple
                                    sx={{
                                        fontSize: isScrolled ? '1.1250em' : '1.3750em',
                                        padding: '12px',
                                        textTransform: "none",
                                        fontFamily: "Inter, sans-serif",
                                        '&:hover': {
                                            color: '#ff6c00',
                                            backgroundColor: 'transparent',
                                        },
                                    }}
                                    onClick={() => handleNavigation('/Sedes')}
                                >
                                    Sedes
                                </Button>
                                <Button
                                    color="inherit"
                                    disableRipple
                                    sx={{
                                        fontSize: isScrolled ? '1.1250em' : '1.3750em',
                                        padding: '12px',
                                        textTransform: "none",
                                        fontFamily: "Inter, sans-serif",
                                        '&:hover': {
                                            color: '#ff6c00',
                                            backgroundColor: 'transparent',
                                        },
                                    }}
                                    onClick={() => handleNavigation('/Contacto')}
                                >
                                    Contacto
                                </Button>
                            </>
                        </div>
                    </Toolbar>
                </AppBar>
            </>
        );
    } else if (variant === 2 && !isSmallScreen) {
        return (
            <>
                <div
                    className={`top-bar scrolled`}
                >
                    <div className='top-bar-info'>
                        <Typography
                            variant="body1"
                            style={{ marginRight: '5px', fontFamily: 'Inter, sans-serif', fontSize: '1.0625em' }}
                        >
                            ¿Necesitas ayuda?
                        </Typography>
                        <Link
                            to={whatsappLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                color: 'White',
                                display: 'flex',
                                alignItems: 'center',
                                textDecoration: 'none',
                                fontFamily: 'Inter, sans-serif',
                                fontSize: '1.0625em',
                            }}
                        >
                            Contáctanos
                            <WhatsAppIcon style={{ marginBottom: '3px', marginLeft: '5px' }} />
                        </Link>
                    </div>

                    <div className='top-bar-info'>
                        <div className="phone-info" style={{ color: 'White' }}>
                            <MailIcon />
                            <Typography
                                variant="body1"
                                style={{ marginLeft: '5px', fontFamily: 'Inter, sans-serif', fontSize: '1.0625em' }}
                            >
                                gerencia@rocaseguros.com
                            </Typography>
                        </div>
                        <div className="sep" style={{ backgroundColor: 'White' }} />
                        <div className="phone-info">
                            <PhoneIcon />
                            <Typography
                                variant="body1"
                                style={{ marginLeft: '5px', fontFamily: 'Inter, sans-serif', fontSize: '1.0625em' }}
                            >
                                (608) 761 9551
                            </Typography>
                        </div>
                    </div>
                </div>
                <AppBar
                    position="fixed"
                    sx={{
                        backgroundColor: 'White',
                        paddingLeft: '10%',
                        paddingRight: '9.5%',
                        marginTop: '38px',
                        top: 0,
                        zIndex: 1000,
                        transition: 'background-color 0.4s ease-in-out',
                    }}
                >
                    <Toolbar sx={{ justifyContent: 'space-between', fontWeight: 'bold', color: 'Black' }}>
                        <div >
                            <Link to="/">
                                <img
                                    src="/Assets/logo-nobg.png"
                                    style={{ height: '65px', marginTop: '10px' }}
                                    alt="logo"
                                />
                            </Link>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', color: '#3b3b3b', gap: '30px' }}>
                            <>
                                <Button
                                    color="inherit"
                                    disableRipple
                                    sx={{
                                        textTransform: "none",
                                        fontSize: '1.1250em',
                                        padding: '12px',
                                        fontFamily: "Inter, sans-serif",
                                        '&:hover': {
                                            color: '#ff6c00',
                                            backgroundColor: 'transparent',
                                        },
                                    }}
                                    onClick={() => handleNavigation('/')}
                                >
                                    Inicio
                                </Button>
                                <Button
                                    color="inherit"
                                    disableRipple
                                    sx={{
                                        fontSize: '1.1250em',
                                        padding: '12px',
                                        textTransform: "none",
                                        fontFamily: "Inter, sans-serif",
                                        '&:hover': {
                                            color: '#ff6c00',
                                            backgroundColor: 'transparent',
                                        },
                                    }}
                                    onClick={() => handleNavigation('/Nosotros')}
                                >
                                    Nosotros
                                </Button>
                                <Button
                                    color="inherit"
                                    disableRipple
                                    sx={{
                                        fontSize: '1.1250em',
                                        padding: '12px',
                                        textTransform: "none",
                                        fontFamily: "Inter, sans-serif",
                                        '&:hover': {
                                            color: '#ff6c00',
                                            backgroundColor: 'transparent',
                                        },
                                    }}
                                    onClick={() => handleNavigation('/Portafolio')}
                                >
                                    Portafolio
                                </Button>
                                <Button
                                    color="inherit"
                                    disableRipple
                                    sx={{
                                        fontSize: '1.1250em',
                                        padding: '12px',
                                        textTransform: "none",
                                        fontFamily: "Inter, sans-serif",
                                        '&:hover': {
                                            color: '#ff6c00',
                                            backgroundColor: 'transparent',
                                        },
                                    }}
                                    onClick={() => handleNavigation('/Sedes')}
                                >
                                    Sedes
                                </Button>
                                <Button
                                    color="inherit"
                                    disableRipple
                                    sx={{
                                        fontSize: '1.1250em',
                                        padding: '12px',
                                        textTransform: "none",
                                        fontFamily: "Inter, sans-serif",
                                        '&:hover': {
                                            color: '#ff6c00',
                                            backgroundColor: 'transparent',
                                        },
                                    }}
                                    onClick={() => handleNavigation('/Contacto')}
                                >
                                    Contacto
                                </Button>
                            </>
                        </div>
                    </Toolbar>
                </AppBar>
            </>
        );
    } else {
        return (
            <>
                <div className={`top-bar scrolled`} style={{ justifyContent: 'center' }}> ¡Aseguramos su tranquilidad! </div>
                <Box sx={{ display: 'flex' }}>
                    <CssBaseline />
                    <AppBar component="nav" sx={{ backgroundColor: 'white', marginTop: '38px' }}>
                        <Toolbar>
                            <div >
                                <Link to="/">
                                    <img
                                        src="/Assets/logo-nobg.png"
                                        style={{ height: '65px', marginTop: '10px' }}
                                        alt="logo"
                                    />
                                </Link>
                            </div>
                            <IconButton
                                aria-label="open drawer"
                                onClick={handleDrawerToggle}
                                edge="end"
                                sx={{
                                    mr: 2,
                                    color: '#515151',
                                    ml: 'auto',
                                    display: { md: 'none' },
                                    '&:hover': {
                                        color: '#ff6c00',
                                        backgroundColor: 'transparent'
                                    }
                                }}
                            >
                                <MenuIcon sx={{ fontSize: 30 }} />
                            </IconButton>
                            <Box sx={{ marginLeft: 'auto', display: { xs: 'none', md: 'block' } }}>
                                {navItems.map((item) => (
                                    <Button
                                        key={item}
                                        disableRipple
                                        sx={{
                                            color: 'inherit',
                                            fontFamily: "Inter, sans-serif",
                                            fontSize: '1.1250em',
                                            padding: '12px 30px',
                                            textTransform: "none",
                                            '&:hover': {
                                                color: '#ff6c00',
                                                backgroundColor: 'transparent',
                                            },
                                        }}
                                        onClick={() => handleNavigation(item === 'Inicio' ? '/' : `/${item}`)}
                                    >
                                        {item}
                                    </Button>
                                ))}
                            </Box>
                        </Toolbar>
                    </AppBar>
                    <nav>
                        <Drawer
                            variant="temporary"
                            open={mobileOpen}
                            onClose={handleDrawerToggle}
                            anchor="right"
                            ModalProps={{
                                keepMounted: true,
                            }}
                            sx={{
                                display: { sm: 'block' },
                                '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                            }}
                        >
                            {drawer}
                        </Drawer>
                    </nav>
                </Box>
            </>
        );
    }
};

export default Header;